import { useParams } from '@reach/router'

export const useRouteParam = key => {
  const params = useParams()

  if (!key) return params

  return params && params[key]
}

export default useRouteParam
